type Branch = typeof import('branch-sdk');
export const getBranch = () => window.branch as unknown as Branch;
